// Vendor
import * as React from 'react';

// Internal
import { Image } from '@src/components/Image/Image';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';
import { SlideReveal } from '@src/components/SlideReveal/SlideReveal';

const RetailTurnsToResale: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        Retail Turns to Resale During Covid to Meet the Changing Needs of
        Consumers
      </h1>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 1}
        className="tup-body max-w-2xl mb-12"
      >
        The future of retail is one where consumers seek value, do more from
        home, and further embrace sustainability. Resale x Retail platforms help
        forward-thinking retailers adapt to a new world.
      </p>

      <SlideReveal>
        <Image
          {...DEFAULT_SAL_PROPS}
          addLink={true}
          alt="Retail and Resale partnerships"
          data-sal-delay={SAL_DELAY * 2}
          data-sal="fade"
          fileName="1i-partnership-chart-white.png"
        />
      </SlideReveal>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-12">
        <blockquote {...DEFAULT_SAL_PROPS} data-sal-delay={SAL_DELAY * 3}>
          <p className="text-base">
            &ldquo;Reuse of clothing is an important component of our brand’s
            sustainability efforts. Even with social distancing in place
            throughout the country, our community was able to upcycle with
            thredUP and uplevel with Reebok UNLOCKED&rdquo;
          </p>
          <footer className="font-bold">
            – Laura Favret, Senior Director Global Brand Strategy
            <Image
              alt="Reebok Logo"
              className="mt-2"
              fileName="reebok-logo.png"
              maxWidth={93}
            />
          </footer>
        </blockquote>
        <blockquote {...DEFAULT_SAL_PROPS} data-sal-delay={SAL_DELAY * 6}>
          <p className="text-base">
            &ldquo;We know that customers, especially millennials, are
            interested in shopping resale clothing. We are thrilled to offer our
            customers the opportunity to reuse garments. We think they’ll be
            surprised and delighted by what they find.&rdquo;
          </p>
          <footer className="font-bold">
            – Denise Incandela, SVP and Group General Manager, Fashion Group
            <Image
              alt="Walmart Logo"
              className="mt-2"
              fileName="walmart-logo.png"
              maxWidth={95}
            />
          </footer>
        </blockquote>
      </div>
    </div>
  );
};

export { RetailTurnsToResale };
